import angular from 'angular';

const dependencies = ['Sq.Workbench'];

/**
 * The Sq.Footer module contains all functionality related to the workbench footer panel
 */
angular.module('Sq.Footer', dependencies);
